<section>
  <div class="shippn-b2b-contactus-hero-wrapper">
    <swiper-container class="shippn-swiper-slider-wrapper-swiper shippn-main-banner-swiper-swiper-container" loop="true"
      pagination="true" pagination-clickable="true" autoplay-delay="10000" autoplay-disable-on-interaction="false"
      id="shippn-main-banner-swiper" keyboard="true">
      <swiper-slide class="main-banner-slide-first more-than-35-countries">
        <div class="container padding-0">
          <div class="b2b-main-banner-text">
            <h1>Ship Worldwide with Confidence</h1>
            <h4>
              Save 60% on shipping and create your labels in minutes with top-rated carriers!
            </h4>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
    <div class="b2b-contactus-hero-overlay">
      <div class="container shippn-homepage-container">
        <div class="b2b-contactus-hero-overlay-content-wrapper">

          <div class="b2b-contactus-carrier-partners-wrapper">
            <div class="shippn-homepage-container container">
              <div class="row">
                <div class="col-md-12">
                  <div class="shippn-b2b-contactus-hero-carriers-wrapper">
                    <div class=" shippn-b2b-contactus-hero-carrier-item">
                      <img fetchpriority="low" loading="lazy"
                        src="../assets/img/b2b-partners-logo/carriers/dhl-logo.png" alt="DHL Logo">
                    </div>
                    <div class=" shippn-b2b-contactus-hero-carrier-item">
                      <img fetchpriority="low" loading="lazy"
                        src="../assets/img/b2b-partners-logo/carriers/fedex-logo.png" alt="Fedex Logo">
                    </div>
                    <div class=" shippn-b2b-contactus-hero-carrier-item">
                      <img fetchpriority="low" loading="lazy"
                        src="../assets/img/b2b-partners-logo/carriers/tnt-express-logo.png" alt="TNT Express logo">
                    </div>
                    <div class=" shippn-b2b-contactus-hero-carrier-item">
                      <img fetchpriority="low" loading="lazy"
                        src="../assets/img/b2b-partners-logo/carriers/la-poste-logo.png" alt="La poste logo">
                    </div>
                    <div class=" shippn-b2b-contactus-hero-carrier-item">
                      <img fetchpriority="low" loading="lazy"
                        src="../assets/img/b2b-partners-logo/carriers/ups-logo.png" alt="UPS Logo">
                    </div>
                    <div class=" shippn-b2b-contactus-hero-carrier-item">
                      <img fetchpriority="low" loading="lazy"
                        src="../assets/img/b2b-partners-logo/carriers/australia-post-logo.png"
                        alt="Australia Post Logo">
                    </div>
                  </div>
                  <p style="font-size:10px; margin-bottom:0;">*These rates are exclusively available for bulk shipments
                    or high-volume merchants.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="quote-and-book-wrapper">
            <div class="container">
              <form class="row b2b-price-calculation-form" form ngNativeValidate [formGroup]="form">
                <div class="col-12 col-md-12 col-lg-12">
                  <label class="shippn-form-label">Country From</label>
                  <div class="select--wrapper" style="background-color: white; border-radius: 5px">
                    <i class="fas fa-chevron-down" style="
                        position: absolute;
                        right: 8px;
                        top: 16px;
                        float: right;
                        color: #222222;
                        font-size: 12px;
                      " aria-hidden="true"></i>
                    <select (change)="changeFromCountry()" [ngClass]="{
                        'border-color-red':
                          form.get('countryFrom').touched &&
                          form.get('countryFrom').invalid
                      }" formControlName="countryFrom" style="width: 100%; border-radius: 5px; height: 42px"
                      class="form-control-sm" autocomplete="tel-country-code">
                      <option value="{{ country.code }}" *ngFor="let country of allCountries">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{
                          country.name
                          }}</span>
                        <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-12 col-lg-12">
                  <label class="shippn-form-label">Country To</label>
                  <div class="select--wrapper" style="background-color: white; border-radius: 5px">
                    <i class="fas fa-chevron-down" style="
                        position: absolute;
                        right: 8px;
                        top: 16px;
                        float: right;
                        color: #222222;
                        font-size: 12px;
                      " aria-hidden="true"></i>
                    <select (change)="changeToCountry()" [ngClass]="{
                        'border-color-red':
                          form.get('countryTo').touched && form.get('countryTo').invalid
                      }" formControlName="countryTo" style="width: 100%; border-radius: 5px; height: 42px"
                      class="form-control-sm" autocomplete="tel-country-code">
                      <option value="{{ country.code }}" *ngFor="let country of allCountries">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{
                          country.name
                          }}</span>
                        <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-12 col-lg-12" style="margin-top: 20px;">
                  <div>
                    <div class="shipment-details-dimension-input-group">
                      <mat-radio-group aria-label="Select an option"
                        class="shipment-details-package-information-radio-group b2b-main-radio-group"
                        formControlName="dimensionMetric">
                        <mat-radio-button *ngIf="form?.controls?.dimensionMetric"
                          [checked]="form?.controls?.dimensionMetric?.value === 'lbs'" type="radio"
                          (change)="changeDimensionsUnit('lbs')" name="dimensionMetric" value="lbs">lbs /
                          inch</mat-radio-button>
                        <mat-radio-button *ngIf="form?.controls?.dimensionMetric"
                          [checked]="form?.controls?.dimensionMetric?.value === 'kg'" type="radio"
                          (change)="changeDimensionsUnit('kg')" name="dimensionMetric" value="kg"
                          class="ng-pristine ng-untouched ng-valid ng-not-empty">kg /
                          cm</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>

                  <div class="shipment-details-dimension-input-group-list element-3">
                    <div class=" shipment-details-dimension-input-group">
                      <label class="shippn-form-label shippn-shipment-details-form-label">
                        Width
                      </label>
                      <div class="shipment-details-input-group input-group"
                        [ngClass]="{'border-color-red':form.get('width').touched && form.get('width').invalid}">
                        <input type="number" formControlName="width" placeholder="0"
                          class="form-control form-control-sm shippn-input b2b-main-input-group-transition"
                          onwheel="this.blur()" (focus)="inputFocus('width')" (blur)="inputBlur('width')">
                        <div class="input-group-append b2b-main-input-group-transition">
                          <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                            <span *ngIf="form.controls.dimensionUnit.value == 'inch'">inch</span>
                            <span *ngIf="form.controls.dimensionUnit.value == 'cm'">cm</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="shippn-padding-none shipment-details-dimension-input-group">
                      <label class="shippn-form-label shippn-shipment-details-form-label">
                        Height
                      </label>
                      <div class="shipment-details-input-group input-group"
                        [ngClass]="{'border-color-red':form.get('height').touched && form.get('height').invalid}">
                        <input type="number" formControlName="height" placeholder="0"
                          class="form-control form-control-sm shippn-input b2b-main-input-group-transition"
                          onwheel="this.blur()" (focus)="inputFocus('height')" (blur)="inputBlur('height')">
                        <div class="input-group-append b2b-main-input-group-transition">
                          <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                            <span *ngIf="form.controls.dimensionUnit.value == 'inch'">inch</span>
                            <span *ngIf="form.controls.dimensionUnit.value == 'cm'">cm</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="shipment-details-dimension-input-group">
                      <label class="shippn-form-label shippn-shipment-details-form-label">
                        Length
                      </label>
                      <div class="shipment-details-input-group input-group"
                        [ngClass]="{'border-color-red':form.get('length').touched && form.get('length').invalid}">
                        <input type="number" formControlName="length" placeholder="0"
                          class="form-control form-control-sm shippn-input b2b-main-input-group-transition"
                          onwheel="this.blur()" (focus)="inputFocus('length')" (blur)="inputBlur('length')">
                        <div class="input-group-append b2b-main-input-group-transition">
                          <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                            <span *ngIf="form.controls.dimensionUnit.value == 'inch'">inch</span>
                            <span *ngIf="form.controls.dimensionUnit.value == 'cm'">cm</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="shipment-details-dimension-input-group">
                      <label class="shippn-form-label shippn-shipment-details-form-label">
                        Weight
                      </label>
                      <div class="shipment-details-input-group input-group"
                        [ngClass]="{'border-color-red':form.get('weight').touched && form.get('weight').invalid}">
                        <input type="number" formControlName="weight" placeholder="0"
                          class="form-control form-control-sm shippn-input b2b-main-input-group-transition"
                          onwheel="this.blur()" (focus)="inputFocus('weight')" (blur)="inputBlur('weight')">
                        <div class="input-group-append b2b-main-input-group-transition">
                          <span class="input-group-text" style="font-size: 14px; padding: 5px;">
                            <span *ngIf="form.controls.weightUnit.value == 'lbs'">lbs</span>
                            <span *ngIf="form.controls.weightUnit.value == 'kg'">kg</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-12 calculate-cta-wrapper" style="margin-top: 20px;">
                  <button class="btn shippn-from-to-area-go-btn" (click)="calculatePrice()">Quote & Book</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<section class="b2b-calculation-section" id="b2b-price-calculation-section" *ngIf="hasCourierOptions">
  <div class="container">
    <div *ngIf="hasCourierOptions" style="margin-top: 20px;transition: 1s; padding:0;"
      class="container shippn-homepage-container">
      <div class="row">
        <div class="col-md-12" style="padding:0">
          <div style=" padding: 20px 0;">
            <div class="table-responsive">
              <table class="table table-borderless">
                <thead>
                  <tr style="border-bottom: 1px solid #70707036;">
                    <th scope="col">Company</th>
                    <th scope="col">Service Type</th>
                    <th scope="col">Estimated Delivery Time</th>
                    <th scope="col">Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of courierData;">
                    <td>
                      <img *ngIf="data.company_id == 1" style="width: 65px;" src="../../assets/tnt.png" alt="tnt logo">
                      <img *ngIf="data.company_id == 2" style="width: 65px;" src="../../assets/ups.png" alt="ups logo">
                      <img *ngIf="data.company_id == 3" style="width: 65px;" src="../../assets/dhl.png" alt="dhl logo">
                      <img *ngIf="data.company_id == 4" style="width: 65px;" src="../../assets/fedex.png"
                        alt="fedex logo">
                      <img *ngIf="data.company_id == 5" style="width: 65px;" src="../../assets/auspost.png"
                        alt="auspost logo">
                      <img *ngIf="data.company_id == 6" style="width: 65px;" src="../../assets/usps.png"
                        alt="usps logo">
                      <img *ngIf="data.company_id == 7" style="width: 65px;" src="../../assets/aramex.png"
                        alt="aramex logo">
                      <img *ngIf="data.company_id == 8" style="width: 65px;" src="../../assets/laposte.png"
                        alt="laposte logo">
                      <img *ngIf="data.company_id == 12" style="width: 65px;" src="../../assets/ems.png"
                        alt="Shippn Partner EMS logo">
                      <img *ngIf="data.company_id == 13" style="width: 65px;" src="../../assets/dpd.png"
                        alt="Courier DPD logo">
                      <img *ngIf="data.company_id == 14" style="width: 60px;" src="../../assets/evri.webp"
                        alt="Courier Evri logo">
                    </td>
                    <td>{{data.service_type_name}}</td>
                    <td>{{data.estimated_delivery}} Business Days</td>
                    <td style="font-weight: bold;" translate="no">{{data.amount}}
                      USD</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="b2b-calculation-section-cta-wrapper" *ngIf="hasCourierOptions">
      <button class="btn shippn-from-to-area-go-btn shippn-white-btn" (click)="goToB2BSignUp()">
        Continue Booking
      </button>
    </div>
    <p style="font-size:10px; margin-bottom:0; margin-top:10px; text-align: center;">*These rates are exclusively available for bulk shipments or high-volume merchants.</p>
  </div>

</section>
<section style=" padding: 50px 0;">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h4 class="text-center">Expand your reach across borders!</h4>
        <div class="become-a-b2b-deal-content">
          <div class="become-a-b2b-deal-content-image">

            <img src="/assets/img/become-an-b2b/shippn-b2b-content-deal-image.webp"
              alt="Shippn B2B Package, Parcel Forwarding  service" class="become-a-b2b-deal-content-image">
          </div>

          <div class="b2b-deal-content-content">
            <div class="become-a-b2b-benefit">
              <strong>Effortless shipping within minutes</strong>
              <span>You can generate shipping labels and have them ready for pickup.</span>
            </div>
            <div class="become-a-b2b-benefit">
              <strong>Competitive Rates</strong>
              <span>Through our strategic partnerships with leading carriers, we offer highly competitive shipping
                rates.</span>
            </div>
            <div class="become-a-b2b-benefit">
              <strong>Swift delivery within 1-5 days</strong>
              <span>Your international customers can receive their orders within 1-5 days.</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>


<section style="background-color: #f4f4f4;">
  <div class="container-fluid" style="padding-bottom: 50px;">
    <div class="shippn-homepage-container container m-pad-0">
      <div class="row">
        <div class="col-md-12">
          <h4 class="header-underline"
            style="text-align: center;font-size: 26px;font-weight: bold;margin-bottom: 20px;margin-top: 50px;">
            What Our Customers Say
          </h4>
          <p class="text-center">Join thousands of satisfied customers worldwide</p>
        </div>
      </div>
      <div class="row shippn-swiper-slider-wrapper">
        <swiper-container class="col-md-12 shippn-swiper-slider-wrapper-swiper tp-swiper-padding" loop="true"
          id="shippnpilotReviewsSwiper" slides-per-view="auto">
          <swiper-slide *ngFor="let tpReview of shippnpilotReviews; let i = index; trackBy:trackByIndex;"
            class="tp-swiper-slide">
            <div class="shippn-reviews-review">
              <div style="display:flex; flex-direction: column; gap: 10px;">
                <div class="shippn-reviews-review-header">
                  <div class="shippn-reviews-review-rating">
                    <div class="shippn-reviews-review-rating-star">
                      <div *ngFor="let index of arrayMaker(tpReview?.review_rating)">
                        <img src="../assets/img/shippn-reviews/star.png" alt="Shippn Reviews Rating Star"
                          style="height: 14px;">
                      </div>
                    </div>
                  </div>
                  <div class="shippn-reviews-review-title">
                    <h5>{{tpReview.review_title}}</h5>
                  </div>
                </div>
                <div class="shippn-reviews-review-content">
                  <p>
                    {{tpReview.review_content}}
                  </p>
                </div>
              </div>
              <div class="shippn-reviews-review-footer">
                <div class="shippn-reviews-review-country-flag">
                  <img src="{{tpReview.review_country_flag}}" alt="{{tpReview.review_country}} flag" height="20px">
                </div>
                <div class="shippn-reviews-review-user">
                  <h6>{{tpReview.review_user}}</h6>
                  <span>{{tpReview.review_country}}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
        <button id="shippnpilotReviewsSwiper-prev" aria-label="Top Routes Slider Prev"
          class="swiper-navigation-custom-btn swiper-custom-btn-prev"><i class="fas fa-chevron-left"></i></button>
        <button id="shippnpilotReviewsSwiper-next" class="swiper-navigation-custom-btn swiper-custom-btn-next"
          aria-label="Top Routes Slider Next"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </div>
</section>